document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initGaleria();
  initVariantes();
  initContadores();
  initBundle();
  initResenasCarrusel();
  initHistoria();
  initHotspots();
});

function initHistoria() {
  var contenedor = document.querySelector('[data-mt-historia]');
  if (!contenedor) return;

  var capitulos = contenedor.querySelectorAll('[data-mt-historia-capitulo]');
  var imagenes = contenedor.querySelectorAll('[data-mt-historia-img]');
  if (!capitulos.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var capitulo = entry.target;
        var indice = capitulo.getAttribute('data-mt-historia-capitulo');
        if (entry.isIntersecting) {
          capitulos.forEach(function (c) { c.classList.remove('mt-historia-activo'); });
          capitulo.classList.add('mt-historia-activo');
          imagenes.forEach(function (img) {
            img.classList.toggle('mt-activa', img.getAttribute('data-mt-historia-img') === indice);
          });
        }
      });
    },
    { threshold: 0.5, rootMargin: '-20% 0px -20% 0px' }
  );

  capitulos.forEach(function (c) { observer.observe(c); });
}

function initHotspots() {
  var puntos = document.querySelectorAll('[data-mt-hotspot]');
  if (!puntos.length) return;

  puntos.forEach(function (punto) {
    punto.addEventListener('click', function (e) {
      e.stopPropagation();
      var abierto = punto.classList.contains('mt-hotspot--abierto');
      puntos.forEach(function (p) { p.classList.remove('mt-hotspot--abierto'); });
      if (!abierto) punto.classList.add('mt-hotspot--abierto');
    });
  });

  document.addEventListener('click', function () {
    puntos.forEach(function (p) { p.classList.remove('mt-hotspot--abierto'); });
  });
}

function initResenasCarrusel() {
  document.querySelectorAll('[data-mt-resenas]').forEach(function (carrusel) {
    var track = carrusel.querySelector('[data-mt-resenas-track]');
    var prev = carrusel.querySelector('[data-mt-resenas-prev]');
    var next = carrusel.querySelector('[data-mt-resenas-next]');
    var puntosContenedor = carrusel.parentElement ? carrusel.parentElement.querySelector('[data-mt-resenas-puntos]') : null;
    var puntos = puntosContenedor ? puntosContenedor.querySelectorAll('[data-mt-resenas-punto]') : [];
    if (!track) return;

    function pasoAncho() {
      var item = track.querySelector('.mt-resenas-item');
      if (!item) return 300;
      var estilo = getComputedStyle(track);
      var gap = parseFloat(estilo.columnGap || estilo.gap || 24);
      return item.getBoundingClientRect().width + gap;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -pasoAncho(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: pasoAncho(), behavior: 'smooth' });
      });
    }

    puntos.forEach(function (punto) {
      punto.addEventListener('click', function () {
        var indice = parseInt(punto.getAttribute('data-mt-resenas-punto'), 10);
        track.scrollTo({ left: indice * pasoAncho(), behavior: 'smooth' });
      });
    });

    if (puntos.length) {
      track.addEventListener('scroll', function () {
        var indiceActual = Math.round(track.scrollLeft / pasoAncho());
        puntos.forEach(function (p, i) {
          p.classList.toggle('mt-activo', i === indiceActual);
        });
      }, { passive: true });
    }
  });
}

function initBundle() {
  var contenedor = document.querySelector('[data-mt-bundle]');
  if (!contenedor) return;

  var opciones = contenedor.querySelectorAll('[data-mt-bundle-opcion]');
  var cantidadInput = document.querySelector('[data-mt-cantidad]');
  if (!opciones.length || !cantidadInput) return;

  function actualizar() {
    opciones.forEach(function (op) {
      var radio = op.querySelector('[data-mt-bundle-radio]');
      if (radio.checked) {
        op.classList.add('mt-bundle-opcion--activa');
        cantidadInput.value = op.getAttribute('data-cantidad');
      } else {
        op.classList.remove('mt-bundle-opcion--activa');
      }
    });
  }

  opciones.forEach(function (op) {
    op.addEventListener('click', function () {
      var radio = op.querySelector('[data-mt-bundle-radio]');
      radio.checked = true;
      actualizar();
    });
  });

  actualizar();
}

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
}

function initGaleria() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;

  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
  var hotspots = galeria.querySelector('[data-mt-hotspots]');
  var flechaPrev = galeria.querySelector('[data-mt-galeria-prev]');
  var flechaNext = galeria.querySelector('[data-mt-galeria-next]');
  if (!principal || !miniaturas.length) return;

  var indiceActual = 0;

  function irA(indice) {
    if (indice < 0) indice = miniaturas.length - 1;
    if (indice >= miniaturas.length) indice = 0;
    indiceActual = indice;
    var mini = miniaturas[indiceActual];
    var nuevaSrc = mini.getAttribute('data-full');
    if (nuevaSrc) principal.src = nuevaSrc;
    miniaturas.forEach(function (m) { m.classList.remove('mt-activa'); });
    mini.classList.add('mt-activa');
    if (hotspots) hotspots.style.display = indiceActual === 0 ? '' : 'none';
  }

  miniaturas.forEach(function (mini, i) {
    mini.addEventListener('click', function () { irA(i); });
  });

  if (flechaPrev) flechaPrev.addEventListener('click', function () { irA(indiceActual - 1); });
  if (flechaNext) flechaNext.addEventListener('click', function () { irA(indiceActual + 1); });

  irA(0);
}

function initVariantes() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;

  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;

  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var idInput = form.querySelector('input[name="id"]');
  var botonesOpcion = form.querySelectorAll('[data-mt-opcion-valor]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioTachadoEl = document.querySelector('[data-mt-precio-tachado]');
  var submitBtn = form.querySelector('[data-mt-submit]');
  var stockAviso = document.querySelector('[data-mt-stock-aviso]');

  function opcionesSeleccionadas() {
    var seleccion = [];
    var grupos = {};
    botonesOpcion.forEach(function (btn) {
      if (btn.classList.contains('mt-seleccionada')) {
        grupos[btn.getAttribute('data-mt-opcion-index')] = btn.getAttribute('data-mt-opcion-valor');
      }
    });
    var maxIndex = 0;
    botonesOpcion.forEach(function (btn) {
      maxIndex = Math.max(maxIndex, parseInt(btn.getAttribute('data-mt-opcion-index'), 10));
    });
    for (var i = 0; i <= maxIndex; i++) {
      seleccion.push(grupos[i]);
    }
    return seleccion;
  }

  function formatoMoneda(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
    });
  }

  function actualizar() {
    var seleccion = opcionesSeleccionadas();
    var variante = variantes.find(function (v) {
      return v.options.every(function (val, i) { return val === seleccion[i]; });
    });

    if (!variante) return;

    idInput.value = variante.id;

    if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
    if (precioTachadoEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioTachadoEl.textContent = formatoMoneda(variante.compare_at_price);
        precioTachadoEl.style.display = '';
      } else {
        precioTachadoEl.style.display = 'none';
      }
    }

    if (submitBtn) {
      submitBtn.disabled = !variante.available;
      submitBtn.textContent = variante.available
        ? submitBtn.getAttribute('data-texto-disponible')
        : submitBtn.getAttribute('data-texto-agotado');
    }
    if (stockAviso) {
      stockAviso.style.display = variante.available ? 'none' : '';
    }

    botonesOpcion.forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-mt-opcion-index'), 10);
      var val = btn.getAttribute('data-mt-opcion-valor');
      var pruebaSeleccion = seleccion.slice();
      pruebaSeleccion[idx] = val;
      var existe = variantes.some(function (v) {
        return v.options.every(function (vv, i) { return vv === pruebaSeleccion[i]; });
      });
      btn.disabled = !existe;
    });
  }

  botonesOpcion.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var idx = btn.getAttribute('data-mt-opcion-index');
      var grupo = form.querySelectorAll('[data-mt-opcion-index="' + idx + '"]');
      grupo.forEach(function (b) { b.classList.remove('mt-seleccionada'); });
      btn.classList.add('mt-seleccionada');
      actualizar();
    });
  });

  actualizar();
}

function initContadores() {
  var contadores = document.querySelectorAll('[data-mt-contador]');
  if (!contadores.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-mt-contador'));
      if (isNaN(fin)) return;
      var duracion = 1400;
      var inicio = null;
      var sufijo = el.getAttribute('data-mt-sufijo') || '';
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valorActual = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = (fin % 1 === 0 ? Math.round(valorActual) : valorActual.toFixed(1)) + sufijo;
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.5 });

  contadores.forEach(function (el) { observer.observe(el); });
}
